module.exports = [[{"x":118,"y":110},{"x":118,"y":110},{"x":119,"y":110},{"x":121,"y":110},{"x":127,"y":110},{"x":141,"y":110},{"x":159,"y":110},{"x":179,"y":110},{"x":200,"y":110},{"x":215,"y":110},{"x":222,"y":110},{"x":223,"y":110},{"x":223,"y":110}]]


//////////////////
// WEBPACK FOOTER
// ./src/data/chinese/one_templates.json
// module id = 138
// module chunks = 0